// extracted by mini-css-extract-plugin
export default {"container":"CaptionedImage_container__0CE4S","innerBox":"CaptionedImage_innerBox__Imc9d","expand":"CaptionedImage_expand__kT5uA"};